<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Wxts from '../../../components/Wxts.vue';

export default {
  name: "FinanceOilFee",
  components: { Wxts },
  data() {
    return {
      baseUrl: 'oil',
      breadcrumb: [
        { name: "财务管理" },
        { name: "油气费汇总表" },
      ],
      wxtsList: [
        {
          name: '如需增减油气站，可在【系统设置】',
          path: '/system/stationConfig',
          pathName: '【油气站配置】',
          tailName: '处设置。',
        },
      ],
      menuIndex: '',
      menu: [
        {
          name: '现金加油',
          path: `/finance/oilFee/cash`,
        },
        {
          name: '油卡加油',
          path: `/finance/oilFee/card`,
        },
        {
          name: '定点加油',
          path: `/finance/oilFee/site`,
        },
      ],
    };
  },
  methods: {
    matchRoute() {
      this.menuIndex = `${this.$route.path}`
      if (this.$route.path.includes('cashorder')) {
        this.menuIndex = `/finance/oilFee/cash`
      } else if (this.$route.path.includes('cardorder')) {
        this.menuIndex = `/finance/oilFee/card`
      } else if (this.$route.path.includes('station') || this.$route.path.includes('site')) {
        this.menuIndex = `/finance/oilFee/site`
      }
    },
  },
  watch: {
    $route() {
      this.matchRoute()
    },
  },
  mounted() {
    this.matchRoute()
  },
};
</script>

<style lang="less" scoped></style>
